import { FC, useEffect, useState } from 'react';
import { animate, useMotionValue } from 'framer-motion';

type AnimatedCounterProps = {
  to: number;
  duration?: number; // duration in seconds
  suffix?: string;
  prefix?: string;
  formatFn?: (value: number) => string;
  start?: boolean;
  delay?: number; // delay in seconds
};

export const AnimatedCounter: FC<AnimatedCounterProps> = ({
  to,
  duration = 2,
  suffix = '',
  prefix = '',
  formatFn,
  start = false,
  delay = 0,
}) => {
  const [display, setDisplay] = useState('');
  const motionValue = useMotionValue(0);

  useEffect(() => {
    if (!start) return;

    const timeout = setTimeout(() => {
      const controls = animate(motionValue, to, {
        duration,
        onUpdate: latest => {
          const value = Math.round(latest);
          setDisplay(`${prefix}${formatFn ? formatFn(value) : value.toString()}${suffix}`);
        },
      });

      return () => controls.stop();
    }, delay * 1000);

    return () => clearTimeout(timeout);
  }, [start]);

  return <span>{display}</span>;
};
